module.exports = __webpack_public_path__ + "img/icon_coordinates9.a52a2bc5.png";